<ng-container *ngTemplateOutlet="liveExample; context: (previewView$ | async) ?? {}"></ng-container>

<ng-template #liveExample let-data="data" let-activeExtension="activeExtension">
  <div
    class="preview"
    [class.preview--cart-control]="isCartControlActive(data, activeExtension)"
    [class.preview--product-upgrade]="isProductUpgradeActive(data, activeExtension)">
    <div class="preview-header">
      <div class="preview-header__left">
        <pdq-heading element="h5">Preview</pdq-heading>
        <pdq-link
          size="small"
          label="Preview In Shopify"
          [clickable]="true"
          [external]="true"
          [url]="shopService.ecommerceEditorUrl()"></pdq-link>
      </div>
      <div class="preview-header__right">
        <div class="device-switch">
          <button (click)="mode.set('desktop')" [class.active]="mode() === 'desktop'">Desktop</button>
          <button (click)="mode.set('mobile')" [class.active]="mode() === 'mobile'">Mobile</button>
        </div>
      </div>
    </div>
    <pdq-divider></pdq-divider>

    @if (mode() === 'desktop') {
      <div class="preview__desktop">
        <ng-template [ngTemplateOutlet]="previewContent"></ng-template>
      </div>
    } @else {
      <div class="preview__mobile">
        <mobile-frame [scrollable]="true">
          <ng-template [ngTemplateOutlet]="previewContent"></ng-template>
        </mobile-frame>
      </div>
    }

    <ng-template #previewContent>
      <!-- Cart Control Only Preview (when editing or creating cart control) -->
      @if (isCartControlActive(data, activeExtension)) {
        <div class="cart-control-preview-wrapper">
          <cart-control-example
            [mode]="data.cartControl.mode"
            [template]="data.cartControl.template"
            [isMobile]="mode() === 'mobile'"></cart-control-example>
        </div>
      } @else if (isDiscountRejectionCouponActive(data, activeExtension)) {
        <div class="drce-preview-wrapper">
          <discount-rejection-coupon-example
            [mode]="data.discountRejectionCoupon.mode"
            [template]="data.discountRejectionCoupon.template"
            [isMobile]="mode() === 'mobile'"></discount-rejection-coupon-example>
        </div>
      } @else if (isDynamicReviewsActive(data, activeExtension)) {
        <div class="dynamic-reviews-preview-wrapper">
          <dynamic-reviews-example
            [mode]="data.dynamicReviews.mode"
            [template]="data.dynamicReviews.template"
            [isMobile]="mode() === 'mobile'"></dynamic-reviews-example>
        </div>
      } @else if (isProductUpgradeActive(data, activeExtension)) {
        <div class="product-upgrade-preview-wrapper">
          <product-upgrade-example
            [mode]="data.productUpgrade.mode"
            [template]="data.productUpgrade.template"
            [isMobile]="mode() === 'mobile'"></product-upgrade-example>
        </div>
      } @else if (isMultiShipmentActive(data, activeExtension)) {
        <multi-shipment-example
          [mode]="data.multiShipment.mode"
          [template]="data.multiShipment.template"
          [isMobile]="mode() === 'mobile'"></multi-shipment-example>
      } @else {
        <!-- Normal Preview (all extensions) -->
        <div
          class="checkout-example-wrapper"
          [ngClass]="{
            'modal-wrapper': data?.isModal,
            'checkout-example-wrapper__desktop': mode() === 'desktop',
            'checkout-example-wrapper__mobile': mode() === 'mobile',
          }">
          <div
            class="checkout-example"
            [ngClass]="{
              'modal-wrapper': data?.isModal,
              'checkout-example__desktop': mode() === 'desktop',
              'checkout-example__mobile': mode() === 'mobile',
            }">
            @if (data?.isModal) {
              @if (!!data?.giftUnlock) {
                <gift-unlock-example
                  [mode]="data.giftUnlock.mode"
                  [template]="data.giftUnlock.template"
                  [previewMode]="data.giftUnlock.previewMode"
                  [isMobile]="mode() === 'mobile'"></gift-unlock-example>
              }
            } @else {
              <div class="nav">
                @for (nav of navigationOptions; track nav) {
                  <span [ngClass]="{ active: nav.active, disabled: nav.disabled }"> {{ nav.label }}</span>
                  <img src="/assets/checkout-icons/chevron-right.svg" alt="" />
                }
              </div>
              @if (!!data?.giftUnlock && data?.giftUnlock?.template?.placementMode !== 'linked') {
                <gift-unlock-example
                  [mode]="data.giftUnlock.mode"
                  [template]="data.giftUnlock.template"
                  [previewMode]="data.giftUnlock.previewMode"
                  [isMobile]="mode() === 'mobile'"></gift-unlock-example>
              }
              <div class="info margin-17">
                <img src="/assets/checkout-icons/example-info-sktn.svg" class="example-info-img" alt="" />
              </div>
              @if (!!data?.multiShipment) {
                <multi-shipment-example
                  [mode]="data.multiShipment.mode"
                  [template]="data.multiShipment.template"
                  [isMobile]="mode() === 'mobile'"></multi-shipment-example>
              }
              @if (!!data?.urgencyBoost) {
                <urgency-boost-example
                  [mode]="data.urgencyBoost.mode"
                  [template]="data.urgencyBoost.template"
                  [isMobile]="mode() === 'mobile'"></urgency-boost-example>
              }
              @if (!!data?.orderProtection) {
                <order-protection-example
                  [mode]="data.orderProtection.mode"
                  [template]="data.orderProtection.template"
                  [isMobile]="mode() === 'mobile'"></order-protection-example>
              }
              @if (!!data?.checkoutContent && data?.checkoutContent?.template?.placementMode !== 'linked') {
                <checkout-content-example
                  [mode]="data.checkoutContent.mode"
                  [template]="data.checkoutContent.template"
                  [isMobile]="mode() === 'mobile'"></checkout-content-example>
              }
              @if (!!data?.checkoutUpsell && data?.checkoutUpsell?.template?.placementMode !== 'linked') {
                <checkout-upsell-example
                  [mode]="data.checkoutUpsell.mode"
                  [template]="data.checkoutUpsell.template"
                  [previewMode]="data.checkoutUpsell.previewMode"
                  [previewedGoalIndex]="data.checkoutUpsell.previewedGoalIndex"
                  [previewedTextType]="data.checkoutUpsell.previewedTextType"
                  [isMobile]="mode() === 'mobile'">
                </checkout-upsell-example>
              }

              @if (!!data?.datePicker && data?.datePicker?.template?.placementMode !== 'linked') {
                <date-picker-example
                  [mode]="data.datePicker.mode"
                  [template]="data.datePicker.template"></date-picker-example>
              }
              @if (
                !!data?.deliveryCountdownTimer &&
                data?.deliveryCountdownTimer?.template?.appearance?.componentPlacement === 'standalone'
              ) {
                <delivery-countdown-timer-example
                  [mode]="data.deliveryCountdownTimer.mode"
                  [template]="data.deliveryCountdownTimer.template"
                  [isMobile]="mode() === 'mobile'"></delivery-countdown-timer-example>
              }
              <div class="shipping-method-title">Shipping methods</div>
              @if (!!data?.shippingRatesFilter) {
                <shipping-rates-filter-example
                  [mode]="data.shippingRatesFilter.mode"
                  [template]="data?.shippingRatesFilter?.template"
                  [isMobile]="mode() === 'mobile'"></shipping-rates-filter-example>
              }
              <div class="shipping-methods margin-17">
                @for (shippingMethodOption of shippingMethodOptions; track shippingMethodOption; let first = $first) {
                  <div
                    class="grid"
                    [ngClass]="{ 'first-item': first && isExtensionSelectedAndInShippingMethods(data) }">
                    <pdq-radio-group>
                      <pdq-radio-button
                        [checked]="shippingMethodOption.selected"
                        [disabled]="!shippingMethodOption.selected"></pdq-radio-button>
                    </pdq-radio-group>
                    <div class="flex-col">
                      <div class="flex-row">
                        <div class="thumb-line" style="width: 50%"></div>
                        <div class="thumb-line" style="width: 15%"></div>
                      </div>
                      <div class="thumb-line" style="width: 100%"></div>
                      @if (
                        shippingMethodOption.selected &&
                        !!data?.datePicker &&
                        data?.datePicker?.template?.placementMode === 'linked'
                      ) {
                        <date-picker-example
                          [mode]="data.datePicker.mode"
                          [template]="data.datePicker.template"></date-picker-example>
                      }
                      @if (
                        shippingMethodOption.selected &&
                        !!data?.checkoutContent &&
                        data?.checkoutContent?.template?.placementMode === 'linked'
                      ) {
                        <checkout-content-example
                          [mode]="data.checkoutContent.mode"
                          [template]="data.checkoutContent.template"
                          [isMobile]="mode() === 'mobile'"></checkout-content-example>
                      }
                      @if (
                        shippingMethodOption.selected &&
                        !!data?.customUpsell &&
                        data?.customUpsell?.template?.placementMode === 'linked'
                      ) {
                        <vip-process-example
                          [mode]="data.customUpsell.mode"
                          [template]="data.customUpsell.template"
                          [isMobile]="mode() === 'mobile'"></vip-process-example>
                      }
                      @if (
                        shippingMethodOption.selected &&
                        !!data?.checkoutUpsell &&
                        data?.checkoutUpsell?.template?.placementMode === 'linked'
                      ) {
                        <checkout-upsell-example
                          [mode]="data.checkoutUpsell.mode"
                          [template]="data.checkoutUpsell.template"
                          [previewMode]="data.checkoutUpsell.previewMode"
                          [previewedGoalIndex]="data.checkoutUpsell.previewedGoalIndex"
                          [previewedTextType]="data.checkoutUpsell.previewedTextType"
                          [isMobile]="mode() === 'mobile'"></checkout-upsell-example>
                      }
                      @if (
                        shippingMethodOption.selected &&
                        !!data?.giftUnlock &&
                        data?.giftUnlock?.template?.placementMode === 'linked'
                      ) {
                        <gift-unlock-example
                          [mode]="data.giftUnlock.mode"
                          [template]="data.giftUnlock.template"
                          [previewMode]="data.giftUnlock.previewMode"
                          [isMobile]="mode() === 'mobile'"></gift-unlock-example>
                      }

                      @if (
                        shippingMethodOption.selected &&
                        !!data?.deliveryCountdownTimer &&
                        data?.deliveryCountdownTimer?.template?.appearance?.componentPlacement === 'linked'
                      ) {
                        <delivery-countdown-timer-example
                          [mode]="data.deliveryCountdownTimer.mode"
                          [template]="data.deliveryCountdownTimer.template"
                          [isMobile]="mode() === 'mobile'"></delivery-countdown-timer-example>
                      }
                    </div>
                  </div>
                }
              </div>
              @if (!!data?.vipProcess && data?.vipProcess?.template?.placementMode !== 'linked') {
                <vip-process-example
                  [mode]="data.vipProcess.mode"
                  [template]="data.vipProcess.template"
                  [isMobile]="mode() === 'mobile'"></vip-process-example>
              }
              @if (!!data?.customUpsell && data?.customUpsell?.template?.placementMode !== 'linked') {
                <vip-process-example
                  [mode]="data.customUpsell.mode"
                  [template]="data.customUpsell.template"
                  [isMobile]="mode() === 'mobile'"></vip-process-example>
              }
              <div class="payment-skeleton margin-17"></div>
              <div class="footer">
                <img src="/assets/checkout-icons/example-footer-sktn.svg" class="example-info-img" alt="" />
              </div>
            }
            @if (!!data?.giftNote) {
              <gift-note-example
                [mode]="data.giftNote.mode"
                [template]="data.giftNote.template"
                [isMobile]="mode() === 'mobile'"></gift-note-example>
            }
            @if (!!data?.hooxpay) {
              <hooxpay-example [mode]="data.hooxpay.mode" [template]="data.hooxpay.template"></hooxpay-example>
            }
            @if (this.checkoutExampleService.showOrderSummaryPreview()) {
              <order-summary-preview></order-summary-preview>
            }
          </div>
        </div>
      }
    </ng-template>
  </div>
</ng-template>
